import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useGenerateWriteOffReport = () => {
  return useMutation({
    mutationFn: async (batchId: string) => {
      await request({
        path: `batches/${batchId}/generate-write-off-report`,
        method: 'POST',
        authenticate: true,
      });
    },
    onSuccess: () => {
      toast.success('Write-off report generation started!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating write-off report!');
    },
  });
};
